module.exports = __webpack_public_path__ + "static/media/chat08.aaa7f0b2.gif";